import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

// Async thunks
export const register = createAsyncThunk(
    'auth/register',
    async (userData, { rejectWithValue }) => {
        try {

            const response = await api.post('/auth/register', userData);
            const { token, user } = response.data;
      
            localStorage.setItem('token', token);
            localStorage.setItem('userId', user.id);
      
            return { user, token };
        } catch (error) {
            return rejectWithValue(
                //error.response?.data?.message || 'Registration failed'
                error.response?.data?.errors || error.response?.data?.message
            );
        }
    }
);

export const login = createAsyncThunk(
    'auth/login',
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await api.post('/auth/login', credentials);
            const { token, user } = response.data;
            localStorage.setItem('token', token);
            localStorage.setItem('userId', user.id);
            return { user, token };
        } catch (error) {
            return rejectWithValue(
                // error.response?.data?.message || 'Login failed'
                error.response?.data?.errors || error.response?.data?.message
            );
        }
    }
);

export const logout = createAsyncThunk('auth/logout', async () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('user');
    return null;
});


const storedUser = localStorage.getItem('user');
const userData = storedUser ? JSON.parse(storedUser) : null;

const initialState = {
    user: localStorage.getItem('userId') || null,
    token: localStorage.getItem('token') || null,
    loading: false,
    error: null,
    isAuthenticated: !!localStorage.getItem('token'),
    attributes: {
        username: userData?.username || '',
        email: userData?.email || '',
        phone: userData?.phone || ''
    }
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
        // Register
        .addCase(register.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(register.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.user.id;
            state.token = action.payload.token;
            state.isAuthenticated = true;
            state.attributes.username = action.payload.user.username;
            state.attributes.email = action.payload.user.email;
            state.attributes.phone = action.payload.user.phone;
            state.attributes.role = action.payload.user.role;
            // state.attributes.isImpersonated = action.payload.user.isImpersonated;

            // Сохраняем данные пользователя в localStorage
            localStorage.setItem('user', JSON.stringify({
                id: action.payload.user.id,
                username: action.payload.user.username,
                email: action.payload.user.email,
                phone: action.payload.user.phone,
                role: action.payload.user.role
                // isImpersonated: action.payload.user.isImpersonated ? action.payload.user.isImpersonated : false
            }));
        })
        .addCase(register.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            console.log(action.payload)
        })
        // Login
        .addCase(login.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(login.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.user.id;
            state.token = action.payload.token;
            state.isAuthenticated = true;
            state.attributes.username = action.payload.user.username;
            state.attributes.email = action.payload.user.email;
            state.attributes.role = action.payload.user.role;
            // state.attributes.isImpersonated = action.payload.user.isImpersonated;
            
            // Сохраняем данные пользователя в localStorage
            localStorage.setItem('user', JSON.stringify({
                id: action.payload.user.id,
                username: action.payload.user.username,
                email: action.payload.user.email,
                phone: action.payload.user.phone,
                role: action.payload.user.role,
                // isImpersonated: action.payload.user.isImpersonated ? action.payload.user.isImpersonated : false
            }));
        })
        .addCase(login.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Logout
        .addCase(logout.fulfilled, (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            state.attributes.username = '';
            state.attributes.email = '';
            state.attributes.phone = '';
            state.attributes.role = '';
        })
    }
});


export const { clearError } = authSlice.actions;
export default authSlice.reducer;